import { useEffect } from 'react';
import { useSocketContext } from './useSocketContext';
export const useSocketMessageListener = (message, callback) => {
    const connection = useSocketContext();
    useEffect(() => {
        if (!connection)
            return;
        const onMessage = (data) => {
            const events = Array.isArray(data) ? data : [data];
            for (const event of events) {
                if (event.action === message)
                    callback(event.payload);
            }
        };
        connection.on('message', onMessage);
        return () => {
            connection.off('message', onMessage);
        };
    }, [connection, callback, message]);
};
//# sourceMappingURL=useSocketMessageListener.js.map